/* Rammens data og regnestykker -- uden UI.

   Hvorfor filen findes: rammelogikken laa inde i den 4.800 linjers
   sektion NF-design-din-ramme-claudev2.liquid, sammenvokset med dens
   markup. Bykort-siden skal bruge de samme tal, men et helt andet UI, og
   den eneste maade at faa det uden to sandheder er at flytte
   regnestykkerne ud, hvor begge kan naa dem.

   Her er ingen DOM og ingen tekst til kunden. Kun katalog, priser og den
   variantloesning Shopify faktisk opkraever efter.

   Det vigtigste at forstaa, foer nogen retter i prisen: rammeprisen er
   ikke én variant. Butikken har fire pris-bucket-produkter, og
   ``findVarianterTilPraecisTotal`` loeser et coin-change-problem for at
   ramme totalen praecist med faerrest mulige linjer. Regner man prisen ud
   ét sted og vaelger variant et andet, opkraever butikken et andet beloeb,
   end kunden fik at se. */
(() => {
  'use strict';

  /* Kataloget kommer fra snippet'et nf-ramme-katalog.liquid, som begge sider
     renderer. Det er med vilje ikke skrevet her: laa listen baade i temaet og
     i denne fil, ville et nyt Pro Material skulle tilfoejes to steder. */
  let katalog = null;

  function laesKatalog() {
    if (katalog) return katalog;
    const blok = document.querySelector('[data-nf-ramme-katalog]');
    if (!blok) {
      console.warn('[ramme-motor] kataloget mangler paa siden');
      katalog = { familier: [], flisebilleder: {}, cdnbilleder: {}, editorbilleder: {}, favoritter: [], farver: [], stilarter: [], proTillaeg: 29 };
      return katalog;
    }
    try {
      katalog = JSON.parse(blok.textContent);
    } catch (fejl) {
      console.warn('[ramme-motor] kataloget kunne ikke laeses:', fejl.message);
      katalog = { familier: [], flisebilleder: {}, cdnbilleder: {}, editorbilleder: {}, favoritter: [], farver: [], stilarter: [], proTillaeg: 29 };
    }
    return katalog;
  }

  /* Samme prioritet som rammesiden altid har brugt: det redigerede foto
     foerst, saa fotoflisen, saa CDN-billedet. De 32 redigerede billeder laa
     tidligere som sektionsindstillinger og kunne derfor kun ses paa rammesiden;
     de er migreret hertil som faste adresser, saa begge sider viser det samme. */
  const billedeFor = (id) => {
    const k = laesKatalog();
    return (k.editorbilleder && k.editorbilleder[id])
      || k.flisebilleder[id]
      || k.cdnbilleder[id]
      || null;
  };

  /* HJOERNEPROEVERNE -- det billede, kunden kan afkode.

     Front-atlasset viser hele rammen forfra som en flad plade med et moerkt
     hul i midten. Det er rammefladens tekstur, ikke et billede at vaelge ud
     fra. Rammesiden viser i stedet et foto af et rammehjoerne, hvor
     overfladen ses taet paa og i skraa vinkel -- og det er dét, City Builder
     skal vise i vaelgeren.

     Adresserne staar i kataloget under ``hjoernebilleder`` og er genereret ud
     af rammesidens egen liste af scripts/build_frame_corner_previews.mjs. */
  /* Originalerne er ~2 MB hver. Et kategorigitter med fjorten af dem ville
     vaere naesten 30 MB paa en telefon, saa der bedes om en bredde. Shopifys
     billed-CDN leverer den mindre udgave; alt andet (fx en lokal testserver)
     faar adressen uroert. */
  const CDN_MOENSTRE = [/cdn\.shopify\.com/, /\/cdn\/shop\//];
  function medBredde(adresse, bredde) {
    if (!adresse || !bredde || !CDN_MOENSTRE.some((m) => m.test(adresse))) return adresse;
    if (/[?&]width=/.test(adresse)) return adresse;
    return adresse + (adresse.includes('?') ? '&' : '?') + `width=${Math.round(bredde)}`;
  }

  const hjoerneBillede = (id, bredde = 0) => {
    const k = laesKatalog();
    const adresse = (k.hjoernebilleder && k.hjoernebilleder[id]) || null;
    return adresse ? medBredde(adresse, bredde) : null;
  };

  /* Rammesidens Pro-traefamilie hedder ``wood-grain-pro``; kataloget kalder
     den ``trae`` og bruger samme id til de fire moenstertraeer. Uden denne
     ene oversaettelse ville Pro-traefamilien faa moenstertraeets forside. */
  /* Rammesidens egen moensterproeve, hvis den findes -- ellers ingenting, og
     saa falder vaelgeren tilbage paa relief-flisen. Kilden er det genererede
     asset nf-ramme-moenstre.generated.js. */
  const moensterProeve = (id) => (window.nfRammeMoenstre?.svgFor(id)) || null;

  const PRO_FAMILIE_FORSIDE = Object.freeze({ trae: 'wood-grain-pro' });

  /* Familiens forside: rammesidens eget valg, hvis det design er med i den
     liste, kunden ser -- ellers det foerste design i familien, der har et
     rigtigt billede. Moensterfamilierne har ingen hjoerneproever, men de har
     alle sammen katalogets eget foto, saa der er altid noget at vise. */
  const harBillede = (id) => Boolean(hjoerneBillede(id) || billedeFor(id));

  function familieForside(familieId, designs, erPro = false) {
    const k = laesKatalog();
    const forsider = k.familiehjoerne || {};
    const noegle = (erPro && PRO_FAMILIE_FORSIDE[familieId]) || familieId;
    const valgt = forsider[noegle];
    const liste = Array.isArray(designs) ? designs : [];
    if (valgt && liste.some((d) => d.id === valgt) && harBillede(valgt)) return valgt;
    if (valgt && erPro && PRO_FAMILIE_FORSIDE[familieId] && harBillede(valgt)) return valgt;
    const foerste = liste.find((d) => harBillede(d.id));
    return foerste ? foerste.id : (liste[0] ? liste[0].id : '');
  }

  /* RAMMENS OVERFLADE -- ét sted for alle previews.

     ``billedeFor`` ovenfor er katalogets salgsfoto og hoerer til vaelgerens
     swatch. Selve rammefladen er noget andet: 3D-viseren tegner Pro Materials
     med den sømløse materialeflise og moenstre med en genereret
     luminansstruktur, som
     ganges med kundens farve. Panoramaets vaegpreview skal vise den samme
     ramme. Laa reglen begge steder, ville de foer eller siden vise hvert sit
     materiale -- og kunden ville se to forskellige rammer paa samme side. */

  /* Katalogets eget salgsfoto af designet -- rammesidens redigerede billede
     foerst, saa fotoflisen, saa CDN-billedet. Det er det billede, rammesiden
     har vist hele tiden, og det er derfor ogsaa det, City Builders vaelger
     skal vise. En genereret proeve er en noedloesning, ikke et alternativ. */
  const katalogBillede = (id, bredde = 0) => medBredde(billedeFor(id), bredde);

  /* MATERIALER TÆT PÅ -- samme autoritative prøve på begge konfiguratorer.

     Standalone-siden har altid vist katalogets godkendte produktfoto tæt på.
     City Builder må ikke opfinde en parallel SVG-gengivelse af det samme
     design: den kan have en anden skala, farve og struktur. Katalogfotoet er
     derfor førstevalg. Hjørnefoto og den genererede prøve er kun sikre
     reserver, hvis et ældre katalog mangler det godkendte foto. Metadataen er
     med vilje med i svaret, så aktiv QA kan bevise hvilken kilde der blev vist. */
  function materialeCloseup(id, bredde = 0) {
    const katalog = katalogBillede(id, bredde);
    if (katalog) return { url: katalog, source: 'catalog-approved', size: 'cover', repeat: 'no-repeat', blend: 'normal' };
    const hjoerne = hjoerneBillede(id, bredde);
    if (hjoerne) return { url: hjoerne, source: 'corner-fallback', size: 'cover', repeat: 'no-repeat', blend: 'normal' };
    const proeve = moensterProeve(id);
    if (proeve) return { url: proeve, source: 'generated-fallback', size: 'cover', repeat: 'no-repeat', blend: 'normal' };
    return { url: null, source: 'none', size: 'cover', repeat: 'no-repeat', blend: 'normal' };
  }

  const materialeUrl = (id) => {
    const k = laesKatalog();
    const atlas = (k.flisebilleder && k.flisebilleder[id]) || '';
    /* Katalogets registrerede front-atlas viser en hel kvadratisk ramme med et
       mørkt motivfelt i midten. Det er egnet som fladt produktatlas, men ikke
       som facade på en 3:2-ramme: cover-beskæringen flytter det mørke center ud
       på skinnerne. Hvert frigivet Pro Material har derfor en tilsvarende
       sømløs ``nf-tile-*``-asset, som standalone-previewet allerede bruger.
       Asset-URL'en kommer stadig fra katalogets Shopify-CDN-base; kun den
       dokumenterede parallelle fil vælges. Ukendte URL-formater falder sikkert
       tilbage til katalogets foto i stedet for at opfinde en tekstur. */
    const atlasName = `nf-atlas-${id}-snapframes-front.webp`;
    if (atlas && atlas.includes(atlasName)) return atlas.replace(atlasName, `nf-tile-${id}.jpg`);
    return atlas || (k.cdnbilleder && k.cdnbilleder[id]) || null;
  };

  /* Hvor mange gange moensterflisen gentages hen over rammefladen. Tallet er
     viserens eget ``texture.repeat`` og staar her, saa vaeggen kan bruge det
     samme. */
  const MOENSTER_GENTAGELSER = 4;

  const moensterFliser = new Map();
  const moensterAdresser = new Map();

  /* Deterministisk luminansstruktur -- aldrig katalogets UI-foto. Fladen er
     hvid, saa den kan ganges med kundens farve uden at aendre kuloeren. */
  function moensterFlise(designId) {
    const key = designId || 'rund';
    if (moensterFliser.has(key)) return moensterFliser.get(key);
    const flise = document.createElement('canvas');
    flise.width = 256;
    flise.height = 256;
    const tegn = flise.getContext('2d', { alpha: false });
    tegn.fillStyle = '#ffffff';
    tegn.fillRect(0, 0, flise.width, flise.height);

    if (key === 'rund') {
      /* Rammesidens Round-visual er en lys radial krumning i en rund flade.
         Her gengives kun luminansen. */
      const baand = 16;
      const krumning = (x0, y0, x1, y1) => {
        const forloeb = tegn.createLinearGradient(x0, y0, x1, y1);
        forloeb.addColorStop(0, '#aaaaaa');
        forloeb.addColorStop(.45, '#ffffff');
        forloeb.addColorStop(1, '#c2c2c2');
        return forloeb;
      };
      tegn.fillStyle = krumning(0, 0, 0, baand);
      tegn.fillRect(0, 0, 256, baand);
      tegn.fillStyle = krumning(0, 256, 0, 256 - baand);
      tegn.fillRect(0, 256 - baand, 256, baand);
      tegn.fillStyle = krumning(0, 0, baand, 0);
      tegn.fillRect(0, 0, baand, 256);
      tegn.fillStyle = krumning(256, 0, 256 - baand, 0);
      tegn.fillRect(256 - baand, 0, baand, 256);
    } else {
      const froe = [...key].reduce((sum, tegnet) => sum + tegnet.charCodeAt(0), 0);
      const afstand = 12 + froe % 9;
      tegn.strokeStyle = 'rgba(75,75,75,.25)';
      tegn.lineWidth = 2;
      tegn.translate(64, 64);
      tegn.rotate(((froe % 7) - 3) * Math.PI / 18);
      for (let forskydning = -192; forskydning <= 192; forskydning += afstand) {
        tegn.beginPath();
        tegn.moveTo(-192, forskydning);
        tegn.lineTo(192, forskydning);
        tegn.stroke();
      }
    }
    moensterFliser.set(key, flise);
    return flise;
  }

  /* Samme flise som en adresse, saa den kan bruges i CSS. */
  function moensterFliseUrl(designId) {
    const key = designId || 'rund';
    if (moensterAdresser.has(key)) return moensterAdresser.get(key);
    let adresse = '';
    try {
      adresse = moensterFlise(key).toDataURL('image/png');
    } catch (fejl) {
      console.warn('[ramme-motor] moensterflisen kunne ikke tegnes:', fejl.message);
    }
    moensterAdresser.set(key, adresse);
    return adresse;
  }

  /* Opdelingen er rammesidens egen: profil, trae og monstre er de
     enkeltfarvede moenstre, der bruger kundens farve. Alt andet er Pro
     Materials med deres egen palette -- og det er praecis den forskel, kunden
     skal kunne se. */
  const MOENSTER_FAMILIER = new Set(['profil', 'trae', 'monstre']);
  const FJERNEDE_FAMILIER = new Set(['jord', 'fordite', 'gitter', 'rustik', 'boelger', 'vandspejl']);
  const GLAT_ID = 'glat';

  /* Traefamilien er delt paa midten, og det er ikke tilfaeldigt: de fire
     foerste er neutrale traestrukturer, der tager kundens farve, mens resten
     -- Walnut, Maple, Cedar, Cherry, Mahogany, Teak -- er farvede materialer
     med deres egen palette. Samme snit som rammesiden bruger. Uden det ville
     Walnut og Maple, de to mest oplagte Pro Materials, ligge under moenstre. */
  const TRAE_MOENSTER_ANTAL = 4;

  function erProDesign(familieId, indeks) {
    if (familieId === 'trae') return indeks >= TRAE_MOENSTER_ANTAL;
    return !MOENSTER_FAMILIER.has(familieId);
  }

  /* Navnene er katalogets engelske, ikke de danske arbejdsnavne. Begge sider
     skal kalde det samme materiale det samme. */
  function visningsnavn(familieId, indeks, design) {
    const liste = (laesKatalog().engelskeNavne || {})[familieId];
    return (liste && liste[indeks]) || design.name || design.navn || design.id;
  }

  function designs(erPro) {
    return laesKatalog().familier
      .filter((f) => !FJERNEDE_FAMILIER.has(f.id))
      .flatMap((f) => (f.designs || []).map((d, i) => ({
        id: d.id,
        navn: visningsnavn(f.id, i, d),
        familie: f.id,
        familieNavn: (laesKatalog().familienavne || {})[f.id] || f.name || f.id,
        billede: billedeFor(d.id),
        pro: erProDesign(f.id, i)
      })))
      .filter((d) => d.pro === erPro && d.id !== GLAT_ID);
  }

  const proMaterialer = () => designs(true);
  const moenstre = () => designs(false);

  /* Favoritterne staar foerst, saa kunden moeder et overskueligt udvalg frem
     for hele kataloget paa én gang. */
  function proFavoritter() {
    const k = laesKatalog();
    const alle = proMaterialer();
    return k.favoritter.map((id) => alle.find((d) => d.id === id)).filter(Boolean);
  }

  const FARVER_FALDBACK = [
    { id: 'sort', navn: 'Sort', swatch: '#1A1A1A' },
    { id: 'hvid', navn: 'Hvid', swatch: '#ECE8DF' },
    { id: 'trae', navn: 'Træ-look', swatch: '#8E6438' },
    { id: 'guld', navn: 'Guld-look', swatch: '#C8A24C' },
    { id: 'hvid-marmor', navn: 'Hvid marmor-look', swatch: '#E8E2DC' }
  ];
  const farver = () => (laesKatalog().farver || []).length ? laesKatalog().farver : FARVER_FALDBACK;
  const stilarter = () => laesKatalog().stilarter || [];

  const PROFILER = [
    { id: 'picture-frame', navn: 'Klassisk', kort: 'Klassisk og enkel' },
    { id: '3d-art-frame', navn: '3D-kunst', kort: 'Ekstra dybde til relief' },
    { id: 'floater-frame', navn: 'Svæveramme', kort: 'Let svævende effekt' }
  ];

  const BAGPLADER = [
    { id: 'none', navn: 'Ingen', pris: 0 },
    { id: 'backplate', navn: 'Bagplade', pris: 39 },
    { id: 'backplate_kickstand', navn: 'Bagplade + kickstand', pris: 59 }
  ];

  const PRO_MATERIALE_TILLAEG = 29;

  /* Bagplade findes kun til de mindste rammer, og ikke til 3D-profilen, hvor
     forkanten er aaben. Samme graenser som rammesiden: korteste side hoejst
     20 cm, laengste hoejst 25. For bykortets kvadratiske stoerrelser betyder
     det, at kun 20 x 20 kan faa bagplade. */
  const bagpladeTilladt = (bredde, hoejde, profilId) => {
    const kort = Math.min(bredde, hoejde);
    const lang = Math.max(bredde, hoejde);
    return kort <= 20 && lang <= 25 && profilId !== '3d-art-frame';
  };

  /* Hvorfor bagpladen ikke kan vaelges -- kort nok til at staa paa et kort. */
  const bagpladeAarsag = (bredde, hoejde, profilId) => {
    if (profilId === '3d-art-frame') return 'Ikke til 3D-kunstprofil';
    if (Math.min(bredde, hoejde) > 20 || Math.max(bredde, hoejde) > 25) return 'Kun til 20 × 20 cm';
    return '';
  };

  /* Uaendret fra rammesiden. Tallene er produktionens, ikke designets:
     119 kr i opsaetning, 18 kr pr. rammedel og 55 oere pr. centimeter
     profil. Rammen er 4 cm bredere end motivet hele vejen rundt, og en
     rammedel kan hoejst vaere 27 cm. */
  function beregnRammepris(breddeCm, hoejdeCm, valg = {}) {
    const ydreBredde = breddeCm + 4;
    const ydreHoejde = hoejdeCm + 4;
    const maksDelCm = 27;
    const dele = 2 * Math.ceil(ydreBredde / maksDelCm) + 2 * Math.ceil(ydreHoejde / maksDelCm);
    const samletLaengde = 2 * ydreBredde + 2 * ydreHoejde;

    let pris = 119;
    pris += dele * 18;
    pris += samletLaengde * 0.55;
    const kunRamme = Math.ceil(pris);

    if (valg.overfladeTillaeg) pris += Number(valg.overfladeTillaeg || 0);
    if (valg.bagplade === 'backplate') pris += 39;
    if (valg.bagplade === 'backplate_kickstand') pris += 59;
    if (valg.bykortPris) pris += Number(valg.bykortPris || 0);

    return {
      pris: Math.ceil(pris),
      kunRamme,
      ydreBredde,
      ydreHoejde,
      dele,
      samletLaengde
    };
  }

  /* Ordret den samme loesning som rammesiden bruger. Butikkens
     pris-buckets er "moenter", og vi skal ramme totalen praecist -- ikke
     rundet op til naermeste bucket, for saa betaler kunden for meget. */
  function findVarianterTilPraecisTotal(total, prisvarianter) {
    const maal = Math.ceil(Number(total) || 0);
    if (maal <= 0) return [];
    const varianter = [...new Map((prisvarianter || [])
      .map((v) => ({ id: v.id, price: Math.round(Number(v.price)) }))
      .filter((v) => v.id && v.price > 0 && v.price <= maal)
      .map((v) => [v.price, v])).values()]
      .sort((a, b) => b.price - a.price);

    const antal = new Int32Array(maal + 1);
    antal.fill(2147483647);
    antal[0] = 0;
    const forrige = new Array(maal + 1).fill(null);
    for (let beloeb = 1; beloeb <= maal; beloeb += 1) {
      for (const v of varianter) {
        if (v.price > beloeb || antal[beloeb - v.price] === 2147483647) continue;
        const kandidat = antal[beloeb - v.price] + 1;
        if (kandidat < antal[beloeb]) {
          antal[beloeb] = kandidat;
          forrige[beloeb] = v;
        }
      }
    }
    if (!forrige[maal]) return [];
    const valgte = [];
    for (let rest = maal; rest > 0;) {
      const v = forrige[rest];
      if (!v) return [];
      valgte.push(v);
      rest -= v.price;
    }
    return [...valgte.reduce((grupper, v) => {
      const nuvaerende = grupper.get(v.id) || { ...v, quantity: 0 };
      nuvaerende.quantity += 1;
      grupper.set(v.id, nuvaerende);
      return grupper;
    }, new Map()).values()];
  }

  /* Priserne hentes fra butikken, ikke fra temaet. Shopify prissaetter
     serverside, og et tal i koden kan vise kunden ét beloeb og opkraeve
     et andet. */
  async function hentPrisvarianter(handles) {
    const gyldige = (handles || []).filter(Boolean);
    if (!gyldige.length) return [];
    const grupper = await Promise.all(gyldige.map(async (handle) => {
      try {
        const svar = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
          headers: { Accept: 'application/json' }
        });
        if (!svar.ok) throw new Error(`produkt ${svar.status}`);
        const produkt = await svar.json();
        return (produkt.variants || [])
          .filter((v) => v.available !== false)
          .map((v) => ({ id: v.id, price: Math.round(Number(v.price) / 100) }));
      } catch (fejl) {
        console.warn('[ramme-motor] kunne ikke hente', handle, fejl.message);
        return [];
      }
    }));
    return grupper.flat()
      .filter((v) => v.id && Number.isFinite(v.price) && v.price > 0)
      .sort((a, b) => a.price - b.price);
  }

  window.nfRammeMotor = {
    laesKatalog,
    farver,
    stilarter,
    proMaterialer,
    proFavoritter,
    moenstre,
    billedeFor,
    materialeUrl,
    hjoerneBillede,
    katalogBillede,
    materialeCloseup,
    moensterProeve,
    familieForside,
    moensterFlise,
    moensterFliseUrl,
    MOENSTER_GENTAGELSER,
    GLAT_ID,
    PROFILER,
    BAGPLADER,
    PRO_MATERIALE_TILLAEG,
    bagpladeTilladt,
    bagpladeAarsag,
    beregnRammepris,
    findVarianterTilPraecisTotal,
    hentPrisvarianter,
    farve: (id) => farver().find((f) => f.id === id) || farver()[0],
    profil: (id) => PROFILER.find((p) => p.id === id) || PROFILER[0],
    bagplade: (id) => BAGPLADER.find((b) => b.id === id) || BAGPLADER[0]
  };
})();
